import { LoginService } from './core/services/login.service';
2
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { QuestionComponent } from './question/question.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {NgxMaskModule} from 'ngx-mask';

import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { GameService } from './core/services/game.service';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';



// translations
// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

import { Globals } from './core/global';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SplashComponent } from './splash/splash.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { StartGameComponent } from './start-game/start-game.component';


import { LoginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { HomeComponent } from './home/home.component';
import { RedeemComponent } from './redeem/redeem.component';
import { NormalizeMsisdnService } from './core/services/normalize-msisdn.service';
import { SelfieComponent } from './selfie/selfie.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { RedeemPackComponent } from './redeem-pack/redeem-pack.component';


@NgModule({
  declarations: [
    AppComponent,
    SplashComponent,
    OnboardingComponent,
    QuestionComponent,
    StartGameComponent,
    SidemenuComponent,
    LoginComponent,
    ProfileComponent,
    HomeComponent,
    RedeemComponent,
    SelfieComponent,
    SubscriptionComponent,
    RedeemPackComponent,

  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    NgxMaskModule.forRoot(),
    HttpClientModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxMaskModule.forRoot()
  ],
  providers: [

    LoginService,
    GameService,
    NormalizeMsisdnService,
    Globals,
    { provide: TranslateModule, multi: false },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
  // return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
